<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" @remoteMethod="getHospital"></FromComm>
			<div class="btngroup">
				<div class="chackboxtow" style="right: 415px;">
					<el-checkbox v-model="OnlySelf">只看自己</el-checkbox>
				</div>
				<div class="chackboxtow">
					<el-checkbox v-model="unBackFill">未回传单号</el-checkbox>
				</div>
				<CommonBtngroup ref="MyApprovalbtngroup" chackbox checktitle="待我审批" marginRight="45px" :qhide="false"
					@select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable" style="display: flex;flex: 1;width: 100%;align-items: center;margin-bottom:0px;">
			<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:useAutoOptional="false" :optional="selectIds.length !== 1"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('delete')" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:useAutoOptional="false" :optional="selectIds.length === 0"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('browse')" backgroundColor="#FFF" :src="require('@/assets/icon/look.png')"
				title="查看" fontSize="14px" @btnclick="update(true)" :optional="selectIds.length !== 1">
			</Commonbtn>
			<CommonbtnUpLoad v-if="auth.includes('add')" types="files" backgroundColor="#FFF" title="导入" fontSize="14px"
				@getFiles="SealUpload" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('submit')" backgroundColor="#FFF" title="提交" fontSize="14px"
				:useAutoOptional="false" :optional="selectIds.length === 0"
				@btnclick="Submit" opwidth="70px" top="353px" :src="require('@/assets/channel/Submit.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('submit')" backgroundColor="#FFF" title="撤回" opwidth="71px" top="352px"
				:useAutoOptional="false" :optional="selectIds.length === 0"
				fontSize="14px" @btnclick="Revoke" :src="require('@/assets/channel/withdraw.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="auth.includes('approval')" title="审批通过" fontSize="14px"
				:useAutoOptional="false" :optional="selectIds.length === 0"
				:src="require('@/assets/channel/Approved.png')" @btnclick="Approved"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="auth.includes('approval')" title="审批驳回" fontSize="14px"
				:useAutoOptional="false" :optional="selectIds.length === 0"
				:src="require('@/assets/channel/Rejectapproval.png')" @btnclick="Rejected"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="auth.includes('approval')" title="审批流程" fontSize="14px"
				:useAutoOptional="false" :optional="selectIds.length !== 1"
				:src="require('@/assets/channel/Approvalprocess.png')" @btnclick="Process"></Commonbtn>
			<div style="margin-left: 6px;display: inline-block;">
				<a class="Dowload" style="text-decoration: underline;min-width: 88px;" @click="down">下载导入模版</a>
			</div>
		</div>

		<div class="BottomTable" style="display: flex;flex: 1;width: 100%;align-items: center;margin-bottom:0px;">
			<Commonbtn v-if="auth.includes('Download')" style="margin: 4px 8px 8px;" backgroundColor="#FFF"
				title="业务员档案下载" fontSize="14px" @btnclick="handExportYw" :src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('Download')" style="margin: 4px 8px 8px;" backgroundColor="#FFF"
				title="医院档案下载" fontSize="14px" @btnclick="handExportHp" :src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn style="margin: 4px 8px 8px;" backgroundColor="#FFF" title="下载产品明细列表" fontSize="14px"
				@btnclick="handExportL3" :src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<div v-if="selectIds.length" style="margin-left: 4px;display: inline-block;">
				<a class="Dowload" style="text-decoration: underline;top:-4px;"
					@click="dialogReturnShow = true">回传单号</a>
			</div>
			<div v-if="selectIds.length" style="margin-left: 4px;display: inline-block;">
				<a class="Dowload" style="text-decoration: underline;top:-4px;" @click="pachDownload">批量下载</a>
			</div>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" @onRowClick="handRowClick" @Upload="handRowUpload" :color="true"
				@Confirm="handRowConfirm" width="1000px" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%" @handleSelectionChange="(e)=>selectIds = e.map(item => item.AppID)">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>

		<div class="Table Table-detail" style="padding-bottom: 24px;" v-if="tableData2.length">
			<Commontable ref="refTableCenter" width="1000px" colnum=7 :tableData="tableData2" :headerData="headerData2"
				:loadingTable="false" height="100%">
			</Commontable>
		</div>

		<div class="Table" style="padding-bottom: 24px;" v-if="tableData3.length">
			<Commontable ref="refTableCenter" width="1000px" colnum=7 :tableData="tableData3" :headerData="headerData3"
				:loadingTable="false" height="100%" @CZClick="handTableRow">
			</Commontable>
		</div>

		<DialogFrom width="1060px" :title="dialogLook?'查看':tableCurr?'修改':'新增'" :OKASCAN="!dialogLook?true:false"
			:dialogVisible="dialogShow" @cancel="cancelEditor" @dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod" @selectChange="selectChange"></FromComm>
			<div class="box-opt" style="padding:18px 6px" :style="{visibility:!dialogLook?'visible':'hidden'}">
				<Commonbtn backgroundColor="#FFF" title="新增产品名称" fontSize="14px" @btnclick="handShowNmd"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>

				<Commonbtn backgroundColor="#FFF" title="新增产品型号" fontSize="14px" @btnclick="handShowPrd"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>

				<Commonbtn backgroundColor="#FFF" title="删除选中" fontSize="14px" @btnclick="handDelPrd"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div class="customer-table">
				<el-table :data="produData" style="width: 100%;"
					@selection-change="(e)=> tableDataSel = e.map(it => it.InvCode||it.PDCode)">
					<el-table-column type="selection" width="60" v-if="!dialogLook" />
					<el-table-column prop="InvAddCode" label="产品型号" width="150" />
					<el-table-column prop="InvName" label="产品名称" />
					<el-table-column prop="Quantity" label="数量">
						<template slot-scope="scope">
							<el-input v-model="scope.row.Quantity" :disabled="dialogLook" placeholder="请输入数量" />
						</template>
					</el-table-column>
					<el-table-column prop="DetailRemark" label="备注">
						<template slot-scope="scope">
							<el-input v-if="!dialogLook" v-model="scope.row.DetailRemark" placeholder="请输入备注" />
							<span v-else style="cursor: pointer; display: block; width: 100%; min-height: 20px;" @dblclick="copyText(scope.row.DetailRemark)" title="双击复制">{{scope.row.DetailRemark}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="LEVEL3" label="LEVEL3" width="100" />
					<el-table-column prop="RegistrationNo" label="注册证" width="170" />
				</el-table>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" :title="`选择产品名称`" :dialogVisible="dialogVisibNmd" @cancel="dialogVisibNmd = false"
			:OKASCAN="false">
			<div class="from">
				<div class="input-tops"
					style="width: 100%;box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);height:110px;">
					<div v-for="(item , index) of formdataNmd" :key="index" style="display: inline-block;">
						<Commondropdownlist ref="topfromname" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color" :disabled="item.disabled"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:event="item.event" :options="item.options" :width="item.width">
						</Commondropdownlist>
					</div>
					<div class="Btngroups">
						<CommonBtngroup :qhide="false" @select="handSelectNmd" @reset="handResetNmd"></CommonBtngroup>
					</div>
				</div>
				<div class="TableFlex" style="margin-top: 24px;">
					<div class="flexBtn">
						<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" style="margin-left:0px !important;"
							@btnclick="handAddNmd" />
					</div>
					<!--.map(it => {return {InvCode: it.InvCode,InvAddCode:it.InvAddCode}})-->
					<Commontable ref="comtable" style="margin-left: 0%;" colnum=7 :tableData="tableDataNmd"
						:headerData="headerDataNmd" height="100%" @handleSelectionChange="(e)=>tableDataSel = e">
					</Commontable>
					<div class="pagination">
						<Pagination :total="pageCountNmd" :pageSize="queryNmd.pageSize"
							@handleCurrentChange="handleCurrentNmd" @handleSizeChange="handleSizeNmd" />
					</div>
				</div>
			</div>
		</DialogFrom>


		<DialogFrom width="1000px" :title="`选择产品型号`" :dialogVisible="dialogVisibPrd" @cancel="dialogVisibPrd = false"
			:OKASCAN="false">
			<div class="from">
				<div class="input-tops"
					style="width: 100%;box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);height:110px;">
					<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
						<Commondropdownlist ref="topfrom" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color" :disabled="item.disabled"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:event="item.event" :options="item.options" :width="item.width">
						</Commondropdownlist>
					</div>
					<div class="Btngroups">
						<CommonBtngroup :qhide="false" @select="handSelectPrd" @reset="handResetPrd"></CommonBtngroup>
					</div>
				</div>
				<div class="TableFlex" style="margin-top: 24px;">
					<div class="flexBtn">
						<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" style="margin-left:0px !important;"
							@btnclick="handAddPrd" />
					</div>
					<!--.map(it => {return {InvCode: it.InvCode,InvAddCode:it.InvAddCode}})-->
					<Commontable ref="comtable" style="margin-left: 0%;" colnum=7 :tableData="tableDataPrd"
						:headerData="headerDataPrd" height="100%" @handleSelectionChange="(e)=>tableDataSel = e">
					</Commontable>
					<div class="pagination">
						<Pagination :total="pageCountPrd" :pageSize="queryPrd.pageSize"
							@handleCurrentChange="handleCurrentPrd" @handleSizeChange="handleSizePrd" />
					</div>
				</div>
			</div>
		</DialogFrom>



		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="dialogVisibleDel = false"
			@dialogOK="dialogOKDel" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这些信息吗？</span>
		</Dialog>

		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="dialogVisiblesdrjg = false"
			@dialogOK="dialogVisiblesdrjg = false">
			<div class="from" style="">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" title="审批流程" :dialogVisible="dialogVisiblesApprovalprocess"
			@cancel="dialogVisiblesApprovalprocess = false" @dialogOK="dialogVisiblesApprovalprocess = false">
			<div class="from">
				<Commontable ref="refTableQuota" width="1000px" colnum=7 :tableData="ApprovalProcessTableData"
					:loadingTable="false" :headerData="ApprovalProcessHeaderData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>


		<DialogFrom width="490px" title="回传单号" :OKASCAN="true" :dialogVisible="dialogReturnShow" @cancel="cancelReturn"
			@dialogOK="dialogOKReturn">
			<FromComm :FromArr="FromReturnEditor" />
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commondropdownlist from '../../../../../../components/common-dropdownlist.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import FromArr from './FormData/FromArr'
	import FromArrEditor from './FormData/FromArrEditor'
	import FromReturnEditor from './FormData/FromReturnEditor'
	import headerData from './TableData/headerData'
	import headerData2 from './TableData/headerData2'
	import headerData3 from './TableData/headerData3'
	import ApprovalProcessHeaderData from './TableData/ApprovalProcessHeaderData'
	import utils from "../../../../../../common/utils";
	import {
		InventoryClassList,
		HospitalList,
		CustomerList,
		ProductList
	} from '@/api/home'
	import {
		GetManufacturerList,
		HelperApprovalFlowStatus
	} from '@/api/channel'
	import {
		GetHelperLevel3,
		GetInventoryList,
		GetAPPSampleList,
		GetAPPSampleInfo,
		DownAPPSampleTemp,
		AddAPPSampleData,
		EditAPPSampleData,
		ExportAPPSampleData,
		ImportAPPSampleData,
		DeleteAPPSampleData,
		SubmitAPPSampleData,
		RevokeAPPSampleData,
		ApproveAPPSampleData,
		RejectAPPSampleData,
		GetHostoryAPPSampleData,
		DetailAPPSampleData,
		UpLoadAttachments,
		GetAttatchments,
		DeleteAttatchment,
		GetHelperSampleTypeForSearch,
		GetHelperSampleType,
		GeneratePdfAPPSample,
		GetHelperAllSaler,
		GetHelperSampleAdvType,
		SetAPPSampleConfirm,
		SetAPPSampleBackFill,
		ExportSalerData,
		ExportHospitalData,
		InvNameLEVEL3Export
	} from '@/api/newsapi'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commondropdownlist,
			Commonbtn,
			DialogFrom,
			Dialog,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				OnlySelf: false,
				unBackFill: false,
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				FromArrEditor: [],
				tableCurr: null,
				tableInfo: null,
				tableData: [],
				headerData: [],
				dialogVisibleDel: false, //删除弹窗
				tableDatadrjg: [],
				dialogVisiblesdrjg: false,
				selectIds: [],
				dialogVisibPrd: false,
				dialogLook: false,
				produData: [], //选中后产品数据
				CusCodeList: [],
				formdata: [{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '70px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: 'L3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'select',
						options: [],
						width: '220px',
						lablewith: '80px',
						event: "level3Chage",
					}
				],
				queryPrd: {
					pageIndex: 1,
					pageSize: 10,
					invAddCode: '',
					invName: '',
					MFCode: '',
					invClass: '',
					LEVEL3: '',
				},
				pageCountPrd: 0,
				headerDataPrd: [{
						types: 'selection',
						label: '复选框',
					}, {
						prop: 'InvAddCode',
						label: '产品型号',
						columnwidth: 130
					},
					{
						prop: 'InvName',
						label: '产品名称',
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 90
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 100
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 100
					},
					{
						prop: 'LEVEL1',
						label: 'LEVEL1',
						columnwidth: 100
					},
					{
						prop: 'MFName',
						label: '生产厂商',
						columnwidth: 170
					}
				],
				tableDataPrd: [], //产品弹窗表格数据
				tableDataSel: [], //产品弹窗选中数据
				ApprovalProcessHeaderData: [],
				ApprovalProcessTableData: [],
				dialogVisiblesApprovalprocess: false,
				tableData2: [],
				headerData2: [],
				auth: [],
				tableData3: [],
				headerData3: [],
				dialogReturnShow: false,
				FromReturnEditor: [],
				dialogVisibNmd: false,
				formdataNmd: [{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: 'L3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'select',
						options: [],
						width: '220px',
						lablewith: '80px',
						event: "level3Chage",
					}
				],
				headerDataNmd: [{
						types: 'selection',
						label: '复选框',
					}, {
						prop: 'RegistrationNo',
						label: '注册证',
						columnwidth: 170
					},
					{
						prop: 'InvName',
						label: '产品名称',
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 90
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 100
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 100
					},
					{
						prop: 'LEVEL1',
						label: 'LEVEL1',
						columnwidth: 100
					},
					{
						prop: 'MFName',
						label: '生产厂商',
						columnwidth: 170
					}
				],
				tableDataNmd: [],
				queryNmd: {
					pageIndex: 1,
					pageSize: 10
				},
				pageCountNmd: 0,
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.FromReturnEditor = JSON.parse(JSON.stringify(FromReturnEditor))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerData2 = JSON.parse(JSON.stringify(headerData2))
			this.headerData3 = JSON.parse(JSON.stringify(headerData3))
			this.ApprovalProcessHeaderData = JSON.parse(JSON.stringify(ApprovalProcessHeaderData))
			this.inventoryClassList();
			this.GetManufacturerList();
			this.HelperApprovalFlowStatus();
			this.getData();
			this.setMenuList();
			this.getHelperSampleTypeForSearch();
			this.getHelperSampleType();
			/////////////
			this.getSampleAdvType();
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.CusWebMenus;
			}
		},
		methods: {
			getSingleSelectedId(actionName) {
				if (this.selectIds.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}`);
					return null;
				}
				return this.selectIds[0];
			},
			//列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					this.query.Inventory = this.FromArr[0].modelvalue;
					this.query.InvClass = this.FromArr[1].modelvalue;
					this.query.MFCode = this.FromArr[2].modelvalue;
					this.query.ApplyCode = this.FromArr[3].modelvalue;
					this.query.Customer = this.FromArr[4].modelvalue;
					this.query.Purpose = this.FromArr[5].modelvalue;
					this.query.CreateTime1 = this.FromArr[6].StartTime;
					this.query.CreateTime2 = this.FromArr[6].EndTime;
					this.query.Status = this.FromArr[7].modelvalue;
					this.query.Hospital = this.FromArr[8].modelvalue;
					this.query.SampleType = this.FromArr[9].modelvalue;
					this.query.TrialFeedbackSubmittedStatus = this.FromArr[10].modelvalue;
					this.query.MyApproval = this.$refs.MyApprovalbtngroup.checkeds ? 1 : 0;
					this.query.UnBackFill = this.unBackFill ? 1 : 0;
					this.query.OnlySelf = this.OnlySelf ? 1 : 0;

					let {
						code,
						data
					} = await GetAPPSampleList(this.query)
					if (code == 0) {
						this.total = data.Count;
						this.tableData = data.data.map(it => {
							it.AreaRatioThd = it.AreaRatio;
							it.RegionRatioThd = it.RegionRatio;
							it.CountryRatioThd = it.CountryRatio;
							return it;
						});
					}
				} finally {
					loading.close();
				}
			},
			async getDetail() {
				let {
					code,
					data
				} = await DetailAPPSampleData({
					AppID: this.tableCurr
				})
				if (code == 0) {
					this.tableData2 = data.map(it => {
						it.PurchaseRatioThd = it.PurchaseRatio;
						return it;
					});
				}
			},
			handRowClick(e) {
				this.tableCurr = e.AppID;
				this.getDetail();
				this.getAttatchments();
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					if (index === 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = '';
					return item;
				})
				this.unBackFill = false;
				this.OnlySelf = false;
				this.getData();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[1].options = []
					this.FromArrEditor[0].options = []
					this.formdata[2].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 生产厂商
			async GetManufacturerList() {
				let {
					code,
					message,
					data
				} = await GetManufacturerList({})
				if (code == 0) {
					this.FromArr[2].options = []
					this.FromArrEditor[2].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.MFName,
							key: item.MFCode,
						}
						this.FromArr[2].options.push(obj)
						this.FromArrEditor[2].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			// 样品类型-搜索框
			async getHelperSampleTypeForSearch() {
				let {
					code,
					message,
					data
				} = await GetHelperSampleTypeForSearch({})
				if (code == 0) {
					this.FromArr[9].options = []
					data.map((item, index) => {
						let obj = {
							value: item.Text,
							key: item.Value + '',
						}
						this.FromArr[9].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			// 样品类型
			async getHelperSampleType() {
				let {
					code,
					message,
					data
				} = await GetHelperSampleType({})
				if (code == 0) {
					this.FromArrEditor[7].options = []
					data.map((item, index) => {
						let obj = {
							value: item.Text,
							key: item.Value + '',
						}
						this.FromArrEditor[7].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			// 审批流状态下拉
			async HelperApprovalFlowStatus() {
				let {
					code,
					data,
					message
				} = await HelperApprovalFlowStatus({})
				if (code == 0) {
					this.FromArr[7].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[7].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			//获取l3数据
			async getHelperLevel3(t) {
				let InvClass = t ? this.queryNmd.invClass : this.queryPrd.invClass;
				let {
					code,
					data
				} = await GetHelperLevel3({
					InvClass: InvClass
				});
				if (code == 0) {
					if (t) {
						this.formdataNmd[1].options = [];
						if (this.$refs.topfromname && this.$refs.topfromname[1]) {
							this.$refs.topfromname[1].modelvalue = '';
						}
						data.map((item, index) => {
							this.formdataNmd[1].options.push({
								key: item.value,
								value: item.key,
							});
						});
					} else {
						this.formdata[2].options = [];
						if (this.$refs.topfrom && this.$refs.topfrom[2]) {
							this.$refs.topfrom[2].modelvalue = '';
						}
						data.map((item, index) => {
							this.formdata[2].options.push({
								key: item.value,
								value: item.key,
							});
						});
					}
				}
			},
			async getHospital(val) {
				let {
					code,
					data
				} = await HospitalList({
					HPName: val.qurey
				})
				if (code == 0) {
					this.FromArr[8].options = []
					data.data.forEach((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID,
						}
						this.FromArr[8].options.push(obj)
					})
				}
			},
			// 下载模板
			async down() {
				let {
					code,
					data
				} = await DownAPPSampleTemp({})
				if (code == 0) {
					window.open(data);
				}
			},
			add() {
				this.produData = [];
				this.dialogLook = false;
				this.dialogShow = true;
				this.tableCurr = null;
				this.FromArrEditor.map((item, index) => {
					item.modelvalue = '';
					item.disabled = false;
					// if (index === 1 || index === 3 || index === 7 || index === 8) {
					// 	item.options = []
					// }
					return item;
				})
				this.FromArrEditor[3].inputtype = 'selectMultiple';
			},
			// 指标删除
			del() {
				if (!this.selectIds.length) {
					this.$message.error('请选择您要删除的数据')
					return
				}
				this.dialogVisibleDel = true
			},
			//审批通过
			async Approved() {
				if (!this.selectIds.length) {
					this.$message.error('请选择您要审批的数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					data,
					message
				} = await ApproveAPPSampleData({
					AppIDs: this.selectIds
				})
				if (code == 0) {
					this.selectIds = [];
					this.$message.success('已审批');
					this.handSearch();
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			Rejected() {
				if (!this.selectIds.length) {
					this.$message.error('请选择您要驳回审批的数据')
					return
				}
				this.$prompt('请输入驳回审批原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(async ({
					value
				}) => {
					const loading = this.$loading({
						lock: true,
						text: '提交中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});

					let {
						code,
						data,
						message
					} = await RejectAPPSampleData({
						AppIDs: this.selectIds,
						RejectReason: value
					})
					if (code == 0) {
						this.selectIds = [];
						this.$message.success('已驳回审批');
						this.handSearch();
						this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
					} else {
						if (data.length) {
							this.$alert(`${data.join('<br/>')}`, '提示', {
								dangerouslyUseHTMLString: true,
								showConfirmButton: false
							});
						} else {
							this.$message.error(message);
						}
					}
					loading.close();
				}).catch(() => {});
			},
			async Process() {
				const appId = this.getSingleSelectedId('审批流程查看');
				if (!appId) return;
				this.tableCurr = appId;
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await GetHostoryAPPSampleData({
					AppID: this.tableCurr
				})
				if (code == 0) {
					this.dialogVisiblesApprovalprocess = true
					this.ApprovalProcessTableData = data
				} else if (code == 1) {
					this.$message.error(message)
					this.dialogVisibleApproved = false
					this.title = '结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else {
					this.$message.error(message)
				}
				loading.close()
			},
			//提交
			async Submit() {
				if (!this.selectIds.length) {
					this.$message.error('请选择您要提交的数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					data,
					message
				} = await SubmitAPPSampleData({
					AppIDs: this.selectIds
				})
				if (code == 0) {
					this.selectIds = [];
					this.$message.success('已提交');
					this.handSearch();
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			//撤回
			async Revoke() {
				if (!this.selectIds.length) {
					this.$message.error('请选择您要撤回的数据')
					return
				}
				this.$prompt('请输入撤回原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(async ({
					value
				}) => {
					const loading = this.$loading({
						lock: true,
						text: '提交中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});

					let {
						code,
						data,
						message
					} = await RevokeAPPSampleData({
						AppIDs: this.selectIds,
						Reason: value
					})
					if (code == 0) {
						this.selectIds = [];
						this.$message.success('已撤回');
						this.handSearch();
						this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
					} else {
						if (data.length) {
							this.$alert(`${data.join('<br/>')}`, '提示', {
								dangerouslyUseHTMLString: true,
								showConfirmButton: false
							});
						} else {
							this.$message.error(message);
						}
					}
					loading.close();
				}).catch(() => {});
			},
			//删除
			async dialogOKDel() {
				const loading = this.$loading({
					lock: true,
					text: '删除中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.dialogVisibleDel = false;
				let {
					code,
					data,
					message
				} = await DeleteAPPSampleData({
					AppIDs: this.selectIds
				})
				if (code == 0) {
					this.selectIds = [];
					this.$message.success('已删除');
					this.handSearch();
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else if (code == 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data;
				} else {
					this.$message.error(message);
				}
				loading.close();
			},
			// 批量导入
			async SealUpload(file) {
				if (file && file.length) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file[0])
					let res = await ImportAPPSampleData(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.handSearch();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
					}
					loading.close();
				}
			},
			//编辑
			async update(look = false) {
				const appId = this.getSingleSelectedId(look ? '查看' : '修改');
				if (!appId) return;
				this.tableCurr = appId;
				this.FromArrEditor[3].inputtype = 'selectSingle';
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				console.log('----->', this.tableCurr);

				let {
					code,
					data
				} = await GetAPPSampleInfo({
					AppID: this.tableCurr
				})
				if (code == 0) {
					this.dialogLook = look;
					this.FromArrEditor = this.FromArrEditor.map((item, index) => {
						item.modelvalue = item.key === 'SampleType' ? data[item.key] + '' : data[item.key];
						item.disabled = look;
						if (index === 1 && data.CusName) {
							item.options = [{
								label: data.CusName,
								value: data.CusCode
							}]
						}
						if (index === 3 && data.HPName) {
							item.options = [{
								label: data.HPName,
								value: data.Hospital
							}]
						}
						if (index === 8 && data.SalerInChargeName) {
							item.options = [{
								label: data.SalerInChargeName,
								value: data.SalerInCharge
							}]
						}
						if (index === 9 && data.AdvTypeName) {
							item.options = [{
								value: data.AdvTypeName,
								key: data.AdvType
							}]
						}
						return item;
					})
					if (data.SampleType == '20002') {
						this.FromArrEditor[8].hidden = false;
					}
					if (data.SampleType == '10002') {
						this.FromArrEditor[9].hidden = false;
					}
					this.produData = data.DetailLists;
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//模糊查询
			async remoteMethod(val) {
				if (val.parsign == 'CusCode') {
					let {
						code,
						data
					} = await CustomerList({
						CusName: val.qurey
					})
					if (code == 0) {
						this.FromArrEditor[1].options = []
						data.data.forEach((item, index) => {
							let obj = {
								label: item.CusName,
								value: item.CusCode
							}
							this.FromArrEditor[1].options.push(obj)
						})
					}
				}
				if (val.parsign == 'Hospital') {
					let {
						code,
						data
					} = await HospitalList({
						HPName: val.qurey,
						HosType: '医院'
					})
					if (code == 0) {
						this.FromArrEditor[3].options = []
						data.data.forEach((item, index) => {
							let obj = {
								label: item.HPName,
								value: item.HPID,
							}
							this.FromArrEditor[3].options.push(obj)
						})
					}
				}
				//负责销售
				if (val.parsign == 'SalerInCharge') {
					let {
						code,
						data
					} = await GetHelperAllSaler({
						InvClass: this.FromArrEditor[0].modelvalue,
						TrueName: val.qurey
					})
					if (code == 0) {
						this.FromArrEditor[8].options = []
						data.forEach((item, index) => {
							let obj = {
								label: item.value,
								value: item.key,
							}
							this.FromArrEditor[8].options.push(obj)
						})
					}
				}
			},
			//分类
			async getSampleAdvType() {
				let {
					code,
					data
				} = await GetHelperSampleAdvType({})
				if (code == 0) {
					this.FromArrEditor[9].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArrEditor[9].options.push(obj)
					})
				}
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map((item, index) => {
					item.modelValue = undefined;
					item.modelvalue = '';
					if (index == 8 || index == 9) {
						item.hidden = true;
					}
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelValue || item.modelvalue ? item.modelValue || item
						.modelvalue : null
				})
				params.DetailLists = this.produData;
				if (this.tableCurr) {
					params.AppID = this.tableCurr;
					let {
						code,
						data,
						message
					} = await EditAPPSampleData(params)
					if (code == 0) {
						this.tableCurr = null;
						this.$message.success('编辑成功');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				} else {
					params.ListHospitalID = params.Hospital;
					delete params.Hospital;
					let {
						code,
						data,
						message
					} = await AddAPPSampleData(params)
					if (code == 0) {
						this.tableCurr = null;
						this.$message.success('新增成功');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			//导出
			async handExport(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.Inventory = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.MFCode = this.FromArr[2].modelvalue;
				this.query.ApplyCode = this.FromArr[3].modelvalue;
				this.query.Customer = this.FromArr[4].modelvalue;
				this.query.Purpose = this.FromArr[5].modelvalue;
				this.query.CreateTime1 = this.FromArr[6].StartTime;
				this.query.CreateTime2 = this.FromArr[6].EndTime;
				this.query.Status = this.FromArr[7].modelvalue;
				this.query.Hospital = this.FromArr[8].modelvalue;
				this.query.SampleType = this.FromArr[9].modelvalue;
				this.query.TrialFeedbackSubmittedStatus = this.FromArr[10].modelvalue;
				this.query.MyApproval = this.$refs.MyApprovalbtngroup.checkeds ? 1 : 0;
				this.query.UnBackFill = this.unBackFill ? 1 : 0;
				this.query.OnlySelf = this.OnlySelf ? 1 : 0;

				let resexprot = await ExportAPPSampleData(this.query)
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `样品申请${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.error('导出失败');
				}
			},
			//业务导出
			async handExportYw(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});


				let resexprot = await ExportSalerData({})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `业务员档案${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.error('导出失败');
				}
			},
			//医院导出
			async handExportHp(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let resexprot = await ExportHospitalData({})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `医院档案${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.error('导出失败');
				}
			},
			//level3导出
			async handExportL3(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let resexprot = await InvNameLEVEL3Export({})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `LEVEL3${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.error('导出失败');
				}
			},
			handShowNmd() {
				if (!this.FromArrEditor[0].modelvalue) {
					this.$message({
						type: 'error',
						message: '请选择产品线！'
					});
					return;
				}
				if (!this.FromArrEditor[2].modelvalue) {
					this.$message({
						type: 'error',
						message: '请选择生产厂商！'
					});
					return;
				}
				this.tableDataNmd = [];
				this.dialogVisibNmd = true;
				this.queryNmd.invClass = this.FromArrEditor[0].modelvalue;
				this.queryNmd.MFCode = this.FromArrEditor[2].modelvalue;
				this.$nextTick(() => {
					this.$forceUpdate();
					this.getHelperLevel3('nmd');
					this.handSelectNmd();
				})
			},
			handShowPrd() {
				if (!this.FromArrEditor[0].modelvalue) {
					this.$message({
						type: 'error',
						message: '请选择产品线！'
					});
					return;
				}
				if (!this.FromArrEditor[2].modelvalue) {
					this.$message({
						type: 'error',
						message: '请选择生产厂商！'
					});
					return;
				}
				this.tableDataSel = [];
				this.dialogVisibPrd = true;
				this.queryPrd.invClass = this.FromArrEditor[0].modelvalue;
				this.queryPrd.MFCode = this.FromArrEditor[2].modelvalue;
				this.$nextTick(() => {
					this.$forceUpdate();
					this.getHelperLevel3();
					this.handSelectPrd();
				})
			},
			/*
			 *选择产品部分
			 **/
			//查询绑定数据
			async getInventoryList() {
				let {
					data,
					code,
					message
				} = await GetInventoryList(this.queryPrd);
				if (code == 0) {
					if (data.data) {
						this.tableDataPrd = data.data;
						this.$nextTick(() => {
							this.$refs.comtable.$refs.multipleTable.clearSelection();
						})
					}
					this.pageCountPrd = data.Count
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//产品弹窗查询
			handSelectPrd() {
				this.queryPrd.pageIndex = 1;
				this.queryPrd.InvAddCode = this.$refs.topfrom[0].modelvalue;
				this.queryPrd.InvName = this.$refs.topfrom[1].modelvalue;
				this.queryPrd.LEVEL3 = this.$refs.topfrom[2].modelvalue;
				this.queryPrd.IsSample = 1;
				this.getInventoryList();
			},
			//产品弹窗重置
			handResetPrd() {
				this.queryPrd.pageIndex = 1;
				this.$refs.topfrom.map((item, index) => {
					item.modelvalue = '';
					return item;
				})
			},
			//弹窗当页
			handleCurrentPrd(e) {
				this.queryPrd.pageIndex = e;
				this.getInventoryList();
			},
			//弹窗分页
			handleSizePrd(e) {
				this.queryPrd.pageSize = e;
				this.getInventoryList();
			},
			//产品弹窗保存
			handAddPrd() {
				if (!this.tableDataSel.length) {
					this.$message({
						type: 'error',
						message: '请勾选'
					});
					return;
				}
				this.dialogVisibPrd = false;
				this.produData = this.produData.concat(JSON.parse(JSON.stringify(this.tableDataSel)));
			},
			//删除指定数据
			handDelPrd() {
				this.produData = this.produData.filter(item => !this.tableDataSel.includes(item.InvCode) && !this
					.tableDataSel.includes(item.PDCode));
			},

			////////////////
			//产品弹窗查询
			handSelectNmd() {
				console.log(this.$refs.topfromname);
				this.queryNmd.pageIndex = 1;
				this.queryNmd.InvName = this.$refs.topfromname[0].modelvalue;
				this.queryNmd.LEVEL3 = this.$refs.topfromname[1].modelvalue;
				this.queryNmd.NeedLEVEL3 = 1;
				this.getProductList();
			},
			//产品弹窗重置
			handResetNmd() {
				this.queryNmd.pageIndex = 1;
				this.$refs.topfromname.map((item, index) => {
					item.modelvalue = '';
					return item;
				})
			},
			//弹窗当页
			handleCurrentNmd(e) {
				this.queryNmd.pageIndex = e;
				this.getProductList();
			},
			//弹窗分页
			handleSizeNmd(e) {
				this.queryNmd.pageSize = e;
				this.getProductList();
			},
			//产品弹窗保存
			handAddNmd() {
				if (!this.tableDataSel.length) {
					this.$message({
						type: 'error',
						message: '请勾选'
					});
					return;
				}
				this.dialogVisibNmd = false;
				this.produData = this.produData.concat(JSON.parse(JSON.stringify(this.tableDataSel)));
			},
			//删除指定数据
			handDelNmd() {
				this.produData = this.produData.filter(item => !this.tableDataSel.includes(item.InvCode));
			},
			/*
			 *选择产品部分
			 **/
			//查询绑定数据
			async getProductList() {
				let {
					data,
					code,
					message
				} = await ProductList(this.queryNmd);
				if (code == 0) {
					if (data.data) {
						this.tableDataNmd = data.data;
						this.$nextTick(() => {
							this.$refs.comtable.$refs.multipleTable.clearSelection();
						})
					}
					this.pageCountNmd = data.Count
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//上传
			async handRowUpload(e) {
				if (e.files.length) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)"
					});
					let formData = new FormData();
					e.files.forEach(it => {
						formData.append("files", it);
					});
					let res = await UpLoadAttachments(formData, this.tableCurr);
					loading.close();
					if (res.code == 0) {
						this.getAttatchments();
						this.$message.success('上传成功！');
					} else {
						this.$message.error(res.message);
					}
				}
			},
			//查询附件列表
			async getAttatchments() {
				let {
					code,
					data
				} = await GetAttatchments({
					AppID: this.tableCurr
				})
				if (code == 0) {
					this.tableData3 = data.map(it => {
						it.czAll = [{
								title: '删除',
								clickName: 'delete',
								BtnFalg: true
							},
							{
								title: '查看',
								clickName: 'download',
								BtnFalg: true
							},
						]
						return it;
					});
				}
			},
			async handTableRow(e) {
				if (e.item.clickName === 'delete') { //删除
					let {
						code,
						data,
						message
					} = await DeleteAttatchment({
						ID: e.row.ID
					})
					if (code == 0) {
						this.getAttatchments();
						this.$message.success('删除成功！');
					} else {
						this.$message.error(message);
					}
				} else {
					window.open(e.row.FileUrl, '_blank');
				}
			},
			downloadFile(url, filename) {
				const a = document.createElement('a');
				a.href = url;
				a.download = filename || 'downloaded-file'; // 设置默认文件名
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			//确认
			handRowConfirm(e) {
				this.$confirm(`<strong>是否进行最终确认</strong>`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(async () => {
					let {
						code,
						data,
						message
					} = await SetAPPSampleConfirm({
						AppID: e.AppID
					})
					if (code == 0) {
						this.getData();
						this.$message.success('确认成功！');
					} else {
						this.$message.error(message);
					}
				}).catch(() => {});
			},
			//取消编辑
			cancelReturn() {
				this.FromReturnEditor = this.FromReturnEditor.map(item => {
					item.modelValue = undefined;
					item.modelvalue = '';
					return item;
				})
				this.dialogReturnShow = false;
				this.$forceUpdate();
			},
			async dialogOKReturn() {
				let params = {
					AppIDs: this.selectIds,
				};
				this.FromReturnEditor.map(item => {
					params[item.key] = item.modelValue || item.modelvalue ? item.modelValue || item
						.modelvalue : null
				})
				let {
					code,
					data,
					message
				} = await SetAPPSampleBackFill(params)
				if (code == 0) {
					this.$message.success('回传成功');
					this.cancelReturn();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
			},
			//触发样品类型
			async selectChange(e) {
				if (e === 7) {
					this.FromArrEditor[8].modelvalue = '';
					this.FromArrEditor[9].modelvalue = '';
					this.FromArrEditor[10].modelvalue = '';
					if (this.FromArrEditor[7].modelvalue === '20002' || this.FromArrEditor[7].modelvalue === '20005') {
						this.FromArrEditor[8].hidden = false;
						this.FromArrEditor[9].hidden = true;
						this.FromArrEditor[10].hidden = true;
					} else if (this.FromArrEditor[7].modelvalue === '10002') {
						this.FromArrEditor[8].hidden = true;
						this.FromArrEditor[9].hidden = false;
						this.FromArrEditor[10].hidden = true;
					} else if (this.FromArrEditor[7].modelvalue === '20003') {
						this.FromArrEditor[8].hidden = true;
						this.FromArrEditor[9].hidden = true;
						this.FromArrEditor[10].hidden = false;
					} else {
						this.FromArrEditor[8].hidden = true;
						this.FromArrEditor[9].hidden = true;
						this.FromArrEditor[10].hidden = true;
					}
				}
			},
			//批量下载
			async pachDownload() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await GeneratePdfAPPSample({
					appIDs: this.selectIds
				})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `样品申请文件${str}`, "rar")
				} else {
					this.$message.warning('导出失败');
				}
			},
			// 复制备注
			copyText(text) {
				if (!text) return;
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(() => {
						this.$notify({
							title: '复制成功',
							message: `粘贴板：【${text}】`,
							type: 'success'
						});
					}).catch(err => {
						this.fallbackCopyToClipboard(text);
					});
				} else {
					this.fallbackCopyToClipboard(text);
				}
			},
			fallbackCopyToClipboard(text) {
				const textarea = document.createElement('textarea');
				textarea.value = text;
				textarea.style.position = 'fixed';
				textarea.style.opacity = '0';
				document.body.appendChild(textarea);
				textarea.select();
				try {
					const successful = document.execCommand('copy');
					if (successful) {
						this.$notify({
							title: '复制成功',
							message: `粘贴板：【${text}】`,
							type: 'success'
						});
					}
				} catch (err) {
					console.error('复制失败', err);
				} finally {
					document.body.removeChild(textarea);
				}
			},
			//设置权限
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '77')[0].Nodes.filter(item => item.NodeID ===
					'1063')[0].Nodes.filter(item => item.NodeID === '1064')[0].Buttons;
				this.auth = NodeInfo.map(it => it.NodeName);
			},
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 280px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: -4px;

			.chackboxtow {
				display: inline-block;
				// border: 1px solid red;
				font-size: 14px;
				color: #333333;
				position: absolute;
				right: 300px;
				top: 20px;

				/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
					color: #e71d43;
				}
			}
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.customer-table {
		/deep/.el-table .el-table__cell {
			padding: 2px 0px !important;
		}

		/deep/.el-input__inner {
			background-color: transparent;
			border: none;
			padding: 0 0px;
		}

		/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #e71d43;
			border-color: #e71d43;
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: #e71d4399;
		color: #ffffff;
	}

	.Table-detail /deep/.el-table .el-table__cell {
		padding: 2px 0px !important;
	}

	.Table-detail /deep/.el-table .cell .cell-remark {
		color: #e71d43;
		font-weight: bold;
	}
</style>
